// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__OHHoa","obliqueLineWrap":"membershipbadge_obliqueLineWrap__34vHA","obliqueLine":"membershipbadge_obliqueLine__KWzKA"};